import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SG_FETCH_SURVEY_STANDARD,
  SG_ADD_SURVEY_STANDARD,
  SG_EDIT_SURVEY_STANDARD,
  SG_DELETE_SURVEY_STANDARD,
} from "constants/actions";
//
import {
  Icon,
  Message,
  Button,
  Header,
  List,
  Input,
  Confirm,
} from "semantic-ui-react";

import { BasicErrorMessage } from "utilities/ErrorMessages";
import ReactJson from "react-json-view";
import Select from "react-select";

//
const Details = ({ employee_record_value, setReload }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [templateId, setTemplateId] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({
    name: null,
  });
  const [orgSelected, setOrgSelected] = useState([]);
  const [valueSelected, setValueSelected] = useState([]);

  const [formErrors, setFormErrors] = useState([]);
  const [pristine, setPristine] = useState(true);
  const [valueChanged, setValueChanged] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [responseEditor, setResponseEditor] = useState({});
  const [repeatEvery, setRepeatEvery] = useState("Never");
  const [repeatHrs, setRepeatHrs] = useState(0);
  const [responseText, setResponseText] = useState("");

  function BackArrow() {
    navigate(`/app/survey-standard`);
  }

  useEffect(() => {
    setTemplateId(id);
  }, [id]);

  useEffect(() => {
    if (templateId) {
      dispatch({
        type: SG_FETCH_SURVEY_STANDARD,
        payload: { id: templateId },
      });
    }
  }, [dispatch, templateId]);

  const { get_survey_standard } = useSelector(
    (state) => ({
      get_survey_standard: state.survey_standard,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (get_survey_standard?.[templateId]) {
      setTemplateDetails(get_survey_standard?.[templateId]);
    }
  }, [get_survey_standard, templateId]);

  useEffect(() => {
    if (get_survey_standard?.created?.id) {
      navigate(
        `/app/survey-standard/details/${get_survey_standard?.created?.id}`
      );
    }
  }, [get_survey_standard.created, navigate]);

  useEffect(() => {
    if (get_survey_standard?.deleted) {
      setReload(Math.random());
      const timer1 = setTimeout(() => {
        navigate(`/app/survey-standard`);
      }, 500);
      return () => clearTimeout(timer1);
    }
  }, [get_survey_standard.deleted, navigate, setReload]);

  function UpdateQuestions() {
    setPristine(false);
    if (formErrors.length === 0) {
      const sortOrder = templateDetails?.question_sort_order.split(",").map(num => parseInt(num.trim()));

        dispatch({
          type: SG_ADD_SURVEY_STANDARD,
          payload: {
            name: templateDetails?.name,
            question_sort_order: sortOrder,
            response: responseEditor,
            repeat_every: repeatEvery,
            repeat_hrs: repeatEvery === "Never" ? 0 : Number(repeatHrs || 0),
          },
        });
        // navigate(`/app/survey-standard/detail/${templateId}`);
  
      setPristine(true);
    }
  }

  // console.log(get_survey_standard)

  useEffect(() => {
    const ErrorList = [];
    if (!templateDetails?.name) {
      ErrorList.push("Enter a Name");
    }

    if (!templateDetails?.question_sort_order) {
      ErrorList.push("Add an Question Sort Order");
    }

    setFormErrors(ErrorList);
  }, [templateDetails, valueSelected, orgSelected, valueChanged]);

  function ChangeFormValues(e, name) {
    // console.log(name, e.target.value)
    let _ques = templateDetails;
    _ques[`${name}`] = e.target.value;
    setTemplateDetails(_ques);
    setValueChanged(e.target.value + name);
  }

  function onJsonChange(edit) {
    if (edit && edit.updated_src !== undefined) {
      setResponseEditor(edit.updated_src);
      try {
        setResponseText(JSON.stringify(edit.updated_src, null, 2));
      } catch (e) {}
      setValueChanged(Math.random());
    }
  }

  function onRepeatEveryChange(option) {
    const value = option?.value;
    setRepeatEvery(value);
    if (value === "Never") {
      setRepeatHrs(0);
    } else if (value === "Week" && (repeatHrs === 0 || repeatHrs == null)) {
      setRepeatHrs(168);
    }
  }

  function loadJsonFromText() {
    try {
      const parsed = JSON.parse(responseText || "{}");
      setResponseEditor(parsed);
      setValueChanged(Math.random());
    } catch (e) {
      alert("Invalid JSON. Please fix and try again.");
    }
  }


  return (
    <>
      <Header as="h2">
        <Icon
          style={{ cursor: "pointer" }}
          onClick={BackArrow}
          name="arrow left"
        />
        Add New Survey Standard
      </Header>
      {formErrors.length > 0 && !pristine && (
        <Message
          negative
          //   onDismiss={clearErrors}
          header="We need these details!"
          list={formErrors}
        />
      )}
      <SectionDiv>
        <BasicErrorMessage />
      </SectionDiv>

      <SectionDiv>
        <FormRow>
          <FormLabel>
            <LabelHead>Name</LabelHead>
          </FormLabel>
          <FormInput>
            <Input
              name="name"
              defaultValue={templateDetails?.name}
              onChange={(e) => ChangeFormValues(e, "name")}
            />
          </FormInput>
        </FormRow>

        <FormRow>
          <FormLabel>
            <LabelHead>Question Sort Order</LabelHead>
          </FormLabel>
          <FormInput>
            <Input
              name="replace_by"
              defaultValue={templateDetails?.question_sort_order}
              onChange={(e) => ChangeFormValues(e, "question_sort_order")}
            />
          </FormInput>
        </FormRow>

        <FormRow>
          <FormLabel>
            <LabelHead>Repeat</LabelHead>
          </FormLabel>
          <FormInput>
            <div style={{ maxWidth: 350 }}>
              <Select
                value={{ value: repeatEvery, label: repeatEvery }}
                onChange={onRepeatEveryChange}
                options={[{ value: "Never", label: "Never" }, { value: "Week", label: "Week" }]}
              />
            </div>
          </FormInput>
        </FormRow>

        <FormRow>
          <FormLabel>
            <LabelHead>Repeat Hours</LabelHead>
          </FormLabel>
          <FormInput>
            <Input
              type="number"
              min={0}
              disabled={repeatEvery === "Never"}
              value={repeatEvery === "Never" ? 0 : repeatHrs}
              onChange={(e) => setRepeatHrs(Number(e.target.value))}
              style={{ maxWidth: 200 }}
            />
          </FormInput>
        </FormRow>
      </SectionDiv>

      <SectionDiv>
        <FormRow>
          <FormLabel>
            <LabelHead>Response JSON</LabelHead>
          </FormLabel>
          <FormInput>
            <div style={{ display: "flex", gap: 20, alignItems: "stretch" }}>
              <div style={{ flex: 1 }}>
                <div style={{ marginBottom: 8, fontWeight: 600 }}>Text (paste JSON)</div>
                <textarea
                  style={{ width: "100%", minHeight: 250, fontFamily: "monospace" }}
                  value={responseText}
                  onChange={(e) => setResponseText(e.target.value)}
                />
                <div style={{ marginTop: 8, display: "flex", gap: 10 }}>
                  <Button size="small" onClick={() => setResponseText(JSON.stringify(responseEditor, null, 2))}>Copy from Editor</Button>
                  <Button size="small" color="blue" onClick={loadJsonFromText}>Load into Editor</Button>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ marginBottom: 8, fontWeight: 600 }}>Visual</div>
                <ReactJson
                  src={responseEditor}
                  onEdit={onJsonChange}
                  onAdd={onJsonChange}
                  onDelete={onJsonChange}
                  displayDataTypes={false}
                  enableClipboard={false}
                  name={false}
                />
              </div>
            </div>
          </FormInput>
        </FormRow>
      </SectionDiv>
      <SectionDiv lastSection={true}>
        <Button floated="right" color="green" onClick={UpdateQuestions}>
          Create
        </Button>
      </SectionDiv>
    </>
  );
};

export default Details;

const SectionDiv = styled.div`
  padding: 10px 0px;
  margin: 10px 0px;
  margin-bottom: ${(props) => (props.lastSection === true ? "100px" : "20px")};
`;

const Container = styled.div`
  display: flex;
`;
const SingleRowContent = styled.div`
  display: flex;
  // justify-content: flex-start;
  flex-direction: row;
`;
const SectionCell = styled.div`
  padding: 10px 10px;
  min-width: 350px;
  display: flex;
  flex-direction: row;
`;

const LabelHead = styled.label`
  font-weight: 700;
  display: block;
`;

const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`;
const FormRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5em;
`;

const FormLabel = styled.div`
  padding: 0.5em 1em 0.5em 0;
  flex: 1;
`;

const FormInput = styled.div`
  flex: 2;
`;
